import * as m from "mithril";

import { NavBar } from '../../components/NavBar';
import AppContext from '../../context/AppContext';
import { MessageProvider } from '../../context/AppMessages';
import LiveButton from "../../components/LiveButton";
import dayjs = require("dayjs");
import buildLanguageChangeActions from "../common/LanguageNavActions";
import TentativeBookingDetails from "../pay/TentativeBookingDetails";
import ModalDialog from "../../components/ModalDialog";
import { TentativeBookingDTO } from "../../apiclient/ApiDtos";
//import './ReviewPage.css';

interface Attrs {
    appContext: AppContext,
    messageProvider: MessageProvider,
    tentativeBooking: TentativeBookingDTO,
    onTravellerInfoUpdateRequested: () => void,
    isBacktracking: boolean,
    onBacktrackRequested: () => void,
    onBacktrackCancelled: () => void,
    onBacktrackConfirmed: () => void,
    onReviewCompleted: () => void
}

function TentativeBookingReviewPage(): m.Component<Attrs> {
    return {
        view(vnode) {
            //let t = vnode.attrs.messageProvider.get;
            let messageProvider = vnode.attrs.messageProvider;
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);
            let { tentativeBooking } = vnode.attrs;

            return [
                m("div.app-layout",
                    [
                        m(NavBar, {
                            title: messageProvider.get("review.title"),
                            canBackPress: true,
                            actionItems: langChangeActionItems,
                            onBackPressed: () => {
                                vnode.attrs.onBacktrackRequested();
                            }
                        }),

                        m("div.app-area-main p-2", [
                            m("div.pb-5", {
                                style: "margin-bottom: 130px; !important"
                            },
                                m(TentativeBookingDetails, {
                                    tentativeBooking: vnode.attrs.tentativeBooking,
                                    messageProvider: messageProvider,
                                    showTravellerInfoUpdateAction: true,
                                    onTravellerInfoUpdateRequested: () => {
                                        vnode.attrs.onTravellerInfoUpdateRequested();
                                    }
                                })
                            )
                            ,
                            m("div.fixed-bottom bg-white border-top p-3",
                                m("div.mb-3",
                                    [
                                        m("div.font-weight-bold.text-secondary text-body-sm",
                                            messageProvider.get("review.ensure_info_correctness")
                                        )
                                    ]
                                ),

                                m(LiveButton, {
                                    class: "btn btn-primary btn-block",
                                    label: messageProvider.get("review.continue"),
                                    onClick: () => {
                                        vnode.attrs.onReviewCompleted();
                                    }
                                })
                            ),
                        ]),



                        vnode.attrs.appContext.isLeavingExtraMarginBottom() ?
                            m("div.app-area-system-nav") : null
                    ]),

                m(ModalDialog, {
                    title: messageProvider.get("warning"),
                    message: tentativeBooking.trip.isSeatSelectionAllowed ? messageProvider.get("seat_will_lost") : messageProvider.get("filled_data_will_lost"),
                    shouldOpen: vnode.attrs.isBacktracking,
                    iconType: 'exclamation_circle',
                    iconThemeClass: " svg-medium svg-warning-dark-2",
                    onClosed: () => {
                        vnode.attrs.onBacktrackCancelled()
                    },

                    actionItems: [
                        {
                            label: "OK",
                            onclick: () => {
                                vnode.attrs.onBacktrackConfirmed()
                            }
                        },
                        {
                            label: "Cancel",
                            onclick: () => {
                                vnode.attrs.onBacktrackCancelled();
                            }
                        }

                    ]
                })
            ]
        }

    }
}

export default TentativeBookingReviewPage;